export const SEARCH_LIGHTBOX_TPA_PAGE_ID = 'site_search_popup_page';
export const SEARCH_LIGHTBOX_CONTROLLER_TYPE = 'search-suggestions-lightbox';
//# sourceMappingURL=constants.js.map